import Settings from '../../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 80,
    TINT: {
        TOP: 0xfe9846,
        BOTTOM: 0xff4d2b,
    },
    SHADOW: { X: 2, Y: 2, TINT: 0x000000, ALPHA: 0.5 },
};

const TWEEN = {
    DURATION: 1000,
    DIST: 200,
    EASE: Phaser.Math.Easing.Sine.Out,
};

export default class Entry extends Phaser.GameObjects.Container {
    private tween: Phaser.Tweens.Tween | null;
    private label!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.tween = null;

        this.setupLabel();
    }

    setupLabel() {
        this.label = this.scene.add.bitmapText(0, 0, LABEL.FONT, '2', LABEL.SIZE);
        this.label.setOrigin(0.5);
        // this.label.setTint(LABEL.TINT);
        this.label.setTint(LABEL.TINT.TOP, LABEL.TINT.TOP, LABEL.TINT.BOTTOM, LABEL.TINT.BOTTOM);
        // this.label.setDropShadow(LABEL.SHADOW.X, LABEL.SHADOW.Y, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add(this.label);
    }

    activate() {
        this.setVisible(true);
        this.setActive(true);

        this.setAlpha(1);
    }

    deactivate() {
        this.setVisible(false);
        this.setActive(false);
    }

    launch(x: number, y: number, damage: number, attack: { isAura: boolean, isCrit: boolean, isEnrageHit: boolean }) {
        this.x = x;
        this.y = y;
        this.label.setText(String(damage));
        if (attack.isAura) this.label.setTint(0x87CEEB)
        else if (!attack.isCrit) this.label.setTint(0xFFFFFF)
        else this.label.setTint(LABEL.TINT.TOP, LABEL.TINT.TOP, LABEL.TINT.BOTTOM, LABEL.TINT.BOTTOM);

        this.tween = this.scene.tweens.add({
            targets: this,
            duration: TWEEN.DURATION,
            ease: TWEEN.EASE,
            y: `-=${TWEEN.DIST}`,
            alpha: 0,
            onComplete: () => this.emit('done', this),
        });
    }
}
